import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ProjectBodyRequest } from '../../../features/feature-edit-project/models/project-body-request.interface'
import { ConfigService } from '../../services/config.service'
import { LogService } from '../../services/log.service'

@Injectable({ providedIn: 'root' })
export class FeatureEPService {
   private _cn = this.constructor.name
   private _httpClient = inject(HttpClient)
   private _logService = inject(LogService)
   private _configService = inject(ConfigService)

   createProject(request: ProjectBodyRequest): Observable<any> {
      this._logService.info(this._cn, this.createProject.name, this._logService.START)
      this._logService.info(this._cn, this.createProject.name, 'create project request body: ', request)
      return this._httpClient.post<ProjectBodyRequest>(`${this._configService.apiUrl}/projects`, request)
   }

   createDraft(request: ProjectBodyRequest): Observable<any> {
      this._logService.info(this._cn, this.createDraft.name, this._logService.START)
      this._logService.info(this._cn, this.createDraft.name, 'create draft request body: ', request)
      return this._httpClient.post<ProjectBodyRequest>(`${this._configService.apiUrl}/projects/draft`, request)
   }

   editProject(id: number, request: ProjectBodyRequest): Observable<any> {
      this._logService.info(this._cn, this.editProject.name, this._logService.START)
      this._logService.info(this._cn, this.editProject.name, 'edit project request id: ', id)
      this._logService.info(this._cn, this.editProject.name, 'edit project request body: ', request)
      return this._httpClient.put<ProjectBodyRequest>(`${this._configService.apiUrl}/projects/${id}`, request)
   }

   editDraft(id: number, request: ProjectBodyRequest): Observable<any> {
      this._logService.info(this._cn, this.editDraft.name, this._logService.START)
      this._logService.info(this._cn, this.editDraft.name, 'edit draft request id: ', id)
      this._logService.info(this._cn, this.editDraft.name, 'edit draft request body: ', request)
      return this._httpClient.put<ProjectBodyRequest>(`${this._configService.apiUrl}/projects/${id}/draft`, request)
   }
}
